module.exports = __webpack_public_path__ + "static/img/TR.4800c1f1.jpg";